import { SuperBillBulk, SuperBillControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  superBillBulk: SuperBillBulk[];
}

export const useBulkUpdateSuperBill = () =>
  useMutationWithLoading(async (params: Params) =>
    new SuperBillControllerApi(getConfigObject()).updateBulkSuperBills(
      params.superBillBulk,
      getXtenantId()
    )
  );
